
export const getSequentialArr = ({ min, max }) => {
  return Array.from({ length: max - min + 1 }, (v, i) => i + min)
}
